import { FeatureSelection } from 'hooks/dialogs/cluster/types';

import { CastctlFeatureSelection } from './types';

export const mapCastctlFeatureSelectionToLegacyFeatureSelection = (
  castctlFeatures: CastctlFeatureSelection
): FeatureSelection => ({
  costMonitoring: true,
  autoscaler: castctlFeatures.autoscaler,
  workloadAutoscaler: castctlFeatures.workloadAutoscaler,
  security: false,
  omni: false,
  nvidiaGpuPlugin: false,
  networkCostMetrics: false,
  gpuMetricsExporter: false,
  reliabilityMetrics: castctlFeatures.reliabilityMetrics,
  kent: false,
});
